import React, { useMemo } from 'react';

import {
  Flex, HStack, Stack, Text,
} from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';

import { Radio, Select } from 'components';
import FrequencyForm from 'containers/Route/Form/Frequency';
import { ChecklistTypes, FrequencyTypes } from 'enums/types';
import { debounceChecklistTypes, debounceRegional } from 'utils/debounces';

export default function ChecklistData(props) {
  const {
    control, watch, register, setValue,
  } = useFormContext();

  const defaultValues = useMemo(() => Object.values(ChecklistTypes).map(
    (type) => ({ label: type, value: type }),
  ), []);

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      border="1px"
      borderColor="gray.200"
      borderRadius={8}
      px={12}
      py={10}
      {...props}>
      <Stack
        width="75%">
        <HStack>
          <Controller
            control={control}
            name="type"
            render={({ field }) => (
              <Select
                label="Tipo"
                isClearable={false}
                defaultOptions={defaultValues}
                loadOptions={debounceChecklistTypes}
                {...field}
              />
            )}
          />
          <Controller
            control={control}
            name="regional"
            render={({ field }) => (
              <Select
                label="Regional"
                loadOptions={debounceRegional}
                {...field}
              />
            )}
          />
        </HStack>
        <Flex
          flexDir="column">
          <Text
            color="gray.600"
            variant="smallSemiBold"
            mb={3}>
            Frequência:
          </Text>
          <Controller
            control={control}
            name="frequency"
            render={({ field }) => (
              <Radio
                mb={7}
                {...field}
                options={[
                  { label: 'Única', value: FrequencyTypes.Single },
                  { label: 'Semanal', value: FrequencyTypes.Weekly },
                  { label: 'Quinzenal', value: FrequencyTypes.Biweekly },
                  { label: 'Mensal', value: FrequencyTypes.Monthly }]}
              />
            )}
          />
        </Flex>
        <FrequencyForm
          withoutOverdue
          frequency={watch('frequency')}
          register={register}
          setValue={setValue}
        />
      </Stack>
    </Flex>

  );
}
